import { ActionTree } from "vuex";
import { RootState, IToken } from "@/types";
import { IUser, UserState } from "@/types/user";
import Axios from "axios";
import { getCookie, removeCookie, setCookie } from "tiny-cookie";

const actions: ActionTree<UserState, RootState> = {
  init: async ({ dispatch }) => {
    const isAccessToken: boolean = await dispatch("checkAccessToken");

    return isAccessToken;
  },

  checkAccessToken: async ({ getters, dispatch }) => {
    const accessToken: string | null = getters.accessToken;
    const abilities: string | null = getters.abilities;
    if (!accessToken || !abilities) {
      return false;
    }

    dispatch("setBearer", accessToken);
    dispatch("setAbilities", abilities);

    await dispatch("getAuthorizedUser");

    return !!getters.isAuthorized;
  },

  getAuthorizedUser: async ({ commit }) => {
    try {
      const response = await Axios.get<IUser>("/user");
      commit("set", response.data);
      return true;
    } catch {
      return false;
    }
  },

  authorize: async ({ dispatch }, token: IToken) => {
    try {
      dispatch("setToken", token);
      dispatch("setAbilities", token.token.accessToken.abilities);
      dispatch("setBearer", token.token.plainTextToken);

      await dispatch("getAuthorizedUser");

      return true;
    } catch {
      return false;
    }
  },

  deauthorize: ({ commit }) => {
    Axios.defaults.headers.Authorization = undefined;
    delete Axios.defaults.headers.Authorization;
    removeCookie("access_token");
    removeCookie("abilities");

    commit("clearUser");
    commit("clearToken");
    commit("clearRole");
  },

  setToken: (state, token: IToken) => {
    setCookie("access_token", token.token.plainTextToken, {
      expires: `8640000s`, // 100day
    });
  },

  setAbilities: ({ commit }, abilities: string) => {
    //画面更新に備えるためCookieにも保存。常用するのはstateの方
    setCookie("abilities", abilities, {
      expires: `8640000s`, // 100day
    });

    commit("abilities", abilities);
  },

  setBearer: (state, accessToken: string) => {
    Axios.defaults.headers.Authorization = `Bearer ${accessToken}`;
  },

  setRedirectUrl: async (state, url: string) => {
    setCookie("redirect_url", url, { expires: "1D" });
  },
  clearRedirectUrl: async () => {
    removeCookie("redirect_url");
  },
};

export default actions;
